export const environment = {
    ENVIRONMENT: 'uat',
    CHATBOT_BASE_URL: 'https://uat-chatbot.nopalcyber.com',
    CHATBOT_BUILD_VERSION: '1.0.0',
    DOMAIN_PREFIX: 'uat-chatbot-app',
    DOMAIN: 'nopalcyber.com',
    CHATBOT_CLOUD_FRONT_URL :'https://d3xhuu0isxchs.cloudfront.net'
};